import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { Colors } from '../../landingPage/style/theme';

HitsIndicator.propTypes = {
  data: PropTypes.shape({
    numberOfHit: PropTypes.number.isRequired,
    usedRequests: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired, // assuming createdAt and expiredOn are strings (e.g., ISO date format)
    expiredOn: PropTypes.string.isRequired,
  }).isRequired,
};

export default function HitsIndicator({data}) {
  const { numberOfHit, usedRequests, createdAt, expiredOn } = data;
  const progressPercentage = (usedRequests / numberOfHit) * 100;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        border: `1px solid ${Colors.primary}`,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 'bold', color: Colors.primary, mb: 1 }}
      >
        API Usage
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Hits Used: <strong>{usedRequests}</strong> / <strong>{numberOfHit}</strong>
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            flexGrow: 1,
            height: 10,
            borderRadius: 5,
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: Colors.primary,
            },
          }}
        />
        <Typography
          variant="body2"
          sx={{ ml: 2, minWidth: 50, color: Colors.primary }}
        >
          {Math.round(progressPercentage)}%
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 2,
          pt: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: Colors.secondary }}>
          Usage Period
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {new Date(createdAt).toLocaleDateString()} - {new Date(expiredOn).toLocaleDateString()}
        </Typography>
      </Box>

    </Box>
  );
}
